<template>
    <div class="DelegationsReportComponent">

        <p v-show="report.length > 0">{{ lang.infotext_1 }}:</p>
        <p v-show="report.length == 0">{{ lang.infotext_2 }}</p>
        <div v-for="item in report" :key="item.id">
            <b-list-group-item>
                <span>{{ lang.label_Type }}:
                    <span v-if="item.type == 'rejected'" class="red">{{typeOfComment(item.type)}}</span>
                    <span v-else-if="item.type == 'confirmed'" class="green">{{typeOfComment(item.type)}}</span>
                    <span v-else>{{typeOfComment(item.type)}}</span>
                    <br>
                    {{ lang.label_Login }}: {{item.login}}
                </span><br>
                <span v-if="item.resourceType=='folder'">{{ lang.label_Start }}:
                    {{longDateToShort(item.dateDelegatedFolder)}}
                </span>
                <span v-if="item.resourceType=='file'">{{ lang.label_End }}:
                    {{longDateToShort(item.dateDelegatedFile)}}
                </span>
                <br>
                <span v-if="item.type!='delegated'">
                    <span v-if="item.type == 'confirmed'&&item.resourceType=='folder'">{{ lang.label_End
                        }}:
                        {{longDateToShort(item.dateConfirmResourceFolder)}}
                    </span>
                    <span v-if="item.type == 'confirmed'&&item.resourceType=='file'">{{ lang.label_End }}:
                        {{longDateToShort(item.dateConfirmResourceFile)}}
                    </span>

                    <span v-if="item.type == 'undodelegated' && item.resourceType == 'folder'">{{ lang.label_End
                        }}:
                        {{ longDateToShort(item.dateUndoDelegatedFolder)}}
                    </span>
                    <span v-if="item.type == 'undodelegated' && item.resourceType == 'file'">{{ lang.label_End }}:
                        {{ longDateToShort(item.dateUndoDelegatedFile)}}
                    </span>
                    <span v-if="item.type == 'rejected' && item.resourceType == 'folder'">{{ lang.label_End
                        }}:
                        {{ longDateToShort(item.dateRejectDelegationFolder)}}
                    </span>
                    <span v-if="item.type == 'rejected' && item.resourceType == 'file'">{{ lang.label_End }}:
                        {{longDateToShort(item.dateRejectDelegationFile)}}
                    </span>
                    <br>
                </span>

                <span v-if="item.resourceType == 'file'">{{ lang.label_File }}: {{item.delegatedResource}} </span>
                <span v-if="item.resourceType == 'folder'">{{ lang.label_Folder }}: {{item.delegatedResource}} </span>
                <br>
                <span>{{ lang.label_Path }}: {{item.path}}</span>
                <br>
                <span v-if="item.type == 'rejected'">{{ lang.label_Reason }}: {{ item.rejectReason }}</span>

            </b-list-group-item>

        </div>
        <br>
    </div>
</template>

<script>
//import { mapState, mapMutations, mapActions, mapGetters, mapTypes } from 'vuex'
import * as Tools from './../../Tools/Tools';

export default {
    name: 'DelegationsReportComponent',
    props:{
    lang: Object
    },
    components: {


    },
    data () {
        return {
            name: 'DelegationsReportComponent',
            report: []

        }
    },
    computed: {
        lastRevisionHistory() {

            let tab = this.$store.getters.revisionHistory;
            let obj = tab[0];
            for (let i = 0, lei = tab.length; i < lei; i++) {

                if (tab[i].revision > obj.revision) {
                    obj = tab[i];
                }
            }

            return obj;
        },
        reloadedAfterAction() {
            return this.$store.getters.reloadedAfterAction;
        },
    },
    created() {

        

    },
    watch: {
        lastRevisionHistory: function () {
            
            
            this.reloadContent();
        },
        reloadedAfterAction: function (newValue, oldValue) {
            

            if (newValue.name == this.name) {
                if (newValue.status == true) {

                    this.reloadContent();

                    newValue.status = false;
                    newValue.name = "";
                    this.$store.dispatch("reloadAfterAction", newValue);
                }
            }

        }
    },
    updated() {

        


    },
    mounted: function () {
        
    },
    methods: {
        reloadContent() {

            

            let vue = this;

            
            const obj = {
                projectRevisionId: this.lastRevisionHistory.id
            }
            
            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getDelegationReport", obj)
                .then((result) => {
                    console.log(result)
                    if (result.status == "OK") {

                        vue.report = result.data;


                    } else {

                    }


                })

            
        },
        longDateToShort(date) {
            return Tools.longDateToShort(date);
        },
        typeOfComment(type) {
            let res = "";
            switch (type) {
                case "delegated":
                    res = this.lang.delegated;
                    break;
                case "confirmed":
                    res = this.lang.confirmed;
                    break;
                case "rejected":
                    res = this.lang.rejected;
                    break;
                case "undodelegated":
                    res = this.lang.undodelegated;
                    break;
    
                default:
                    res = ""
                    }


            return res;
        }

    }
}
</script>


<style lang="scss">


    @import "./../../scss/_custom.scss";
    .list-group-item {
        margin-top: 5px;
    }
    .red {
        color: $orange;
        font-weight: 700;
    }

    .green {
        color: $green;
        font-weight: 700;
    }
</style>



// WEBPACK FOOTER //
// src/components/shared/DelegationsReportComponent.vue